import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { IdentityStore } from '../stores/IdentityStore';
import { AuthService } from '../services/AuthService';

export const authGuard: CanActivateFn = (route, state) => {
  if (!inject(IdentityStore).identity()) {
    inject(AuthService).logout();

    return false;
  }

  return true;
};
